export default "https://cdn-static.gokick.com/assets/9175df2ab050434674d4a27e4dae3ab0ebb22d80/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";